export const BOOLEAN_DROPDOWN = [
  { label: 'True', value: true },
  { label: 'False', value: false },
]
